import { c as i } from "../lit-element-8JrrHldg.js";
import { S as a } from "../shoelace-event-controller-BFWPTmUE.js";
import { S as c } from "../chunk.ZSH6VD4N-C_iD5Mw7.js";
import "../chunk.5J7BMMD5-Duf78PT9.js";
import "../chunk.WLV3FVBR-BO0XtQ7O.js";
import "../chunk.TUVJKY7S-CZwfrQkU.js";
import "../chunk.UYAO2JRR-CUGf3xdB.js";
var d = c;
c.define("sl-dropdown");
var h = Object.defineProperty, f = Object.getOwnPropertyDescriptor, m = (l, t, r, o) => {
  for (var e = o > 1 ? void 0 : o ? f(t, r) : t, s = l.length - 1, n; s >= 0; s--)
    (n = l[s]) && (e = (o ? n(t, r, e) : n(e)) || e);
  return o && e && h(t, r, e), e;
};
let p = class extends d {
  constructor() {
    super(), new a(this, [
      "sl-show",
      "sl-after-show",
      "sl-hide",
      "sl-after-hide"
    ]);
  }
  handleSelectOption() {
    this.stayOpenOnSelect || (this.open = !1);
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("p-select", this.handleSelectOption);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("p-select", this.handleSelectOption);
  }
};
p = m([
  i("pwc-dropdown")
], p);
export {
  p as PwcDropdown
};
